export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', 'G-3JHR43Q7GT', {
      page_path: path
    });
  }
};

export const trackEvent = (category, action, label = null, value = null) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
}; 